import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col sm:flex-col container pl-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "py-3 bg-opacity-30 mb-12 font-bold w-32 rounded text-2xl" }, "Subscriptions", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "py-3 bg-opacity-30 mb-6 font-semibold rounded text-xl text-Secondary self-center" }, " Current Subscriptions ", -1)
const _hoisted_6 = { class: "space-y-16" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "my-6" }, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "py-3 bg-opacity-30 mb-6 font-semibold w-46 rounded text-xl text-Secondary" }, " Available Subscriptions ", -1)
const _hoisted_10 = { class: "flex flex-col md:flex-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold" }, "Solarus.club Javascript Monthly"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-6" }, "Script access on a monthly basis.")
], -1)
const _hoisted_12 = { class: "mt-10 md:mt-0 md:ml-auto md:px-4 items-center justify-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold md:text-center" }, [
  /*#__PURE__*/_createTextVNode(" $4.99/mo. "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-normal" }, "USD")
], -1)
const _hoisted_14 = {
  key: 0,
  class: "mx-auto h-5 w-5 animate-spin text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "mx-auto"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "my-6" }, null, -1)
const _hoisted_20 = { class: "flex flex-col md:flex-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold" }, "Solarus.club Javascript 3 Month"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-10" }, "Script access on a quarterly basis.")
], -1)
const _hoisted_22 = { class: "mt-10 md:mt-0 md:ml-auto md:px-4 items-center justify-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex md:justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white bg-Secondary bg-opacity-20 rounded w-20 text-center" }, "Save 15%")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold md:text-center mt-4" }, [
  /*#__PURE__*/_createTextVNode(" $12.99/quarterly. "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-normal" }, "USD")
], -1)
const _hoisted_25 = {
  key: 0,
  class: "mx-auto h-5 w-5 animate-spin text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "mx-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubscriptionCard = _resolveComponent("SubscriptionCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isSubscriptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoBilling && _ctx.gotoBilling(...args))),
              class: "bg-Secondary w-72 h-10 py-1 rounded mr-4 ml-auto text-base font-normal"
            }, " Manage subscriptions (Billing Info) ")
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptions, (sub) => {
              return (_openBlock(), _createElementBlock("div", {
                key: sub.Sub_ID
              }, [
                _createVNode(_component_SubscriptionCard, {
                  onModalOpen: _cache[1] || (_cache[1] = ()=>{}),
                  renewal_date: new Date(sub.Cancel_At).toLocaleDateString(),
                  isSubActive: sub.Active,
                  cancel_at_end: sub.Cancel_At_End,
                  name: sub.Name,
                  description: sub.Description,
                  subscription_id: sub.Sub_ID
                }, null, 8, ["renewal_date", "isSubActive", "cancel_at_end", "name", "description", "subscription_id"])
              ]))
            }), 128))
          ]),
          _hoisted_7
        ]))
      : _createCommentVNode("", true),
    (_ctx.purchasable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.buy1Month && _ctx.buy1Month(...args))),
                class: "bg-Secondary w-56 py-2 rounded mt-6 flex flex-row"
              }, [
                (!_ctx.buttonActive1Month)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_17))
                  : _createCommentVNode("", true),
                (_ctx.buttonActive1Month)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Buy Now"))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _hoisted_24,
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.buy3Month && _ctx.buy3Month(...args))),
                class: "bg-Secondary w-56 py-2 rounded mt-6 flex flex-row"
              }, [
                (!_ctx.buttonActive3Month)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_28))
                  : _createCommentVNode("", true),
                (_ctx.buttonActive3Month)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Buy Now"))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}